import lime from '@bikes/assets/lime.png';
import forest from '@bikes/assets/forest.png';
import forestRiver from '@bikes/assets/forestriver.png';
import santander from '@bikes/assets/santander.png';
import voiScooter from '@bikes/assets/voi-scooter.png';
import limeScooter from '@bikes/assets/lime-scooter.png';
import voiBike from '@bikes/assets/voi-bike.png';
import bolt from '@bikes/assets/bolt-bike.png';

export enum HireBikeCompanies {
  Lime = 'Lime',
  Forest = 'Forest',
  ForestRiver = 'ForestRiver',
  Santander = 'Santander',
  Voi = 'Voi',
  Bolt = 'Bolt',
}

export enum HireScooterCompanies {
  Voi = 'Voi',
  Lime = 'Lime',
}

export const displayText = (
  hireLabel: HireBikeCompanies | HireScooterCompanies | null,
) => (hireLabel === 'ForestRiver' ? 'Forest (River)' : hireLabel);

export enum CompaniesEmails {
  Lime = 'support@li.me',
  Forest = 'cs@humanforest.co.uk',
  ForestRiver = 'cs@humanforest.co.uk',
  Voi = 'support@voi.com',
  Santander = 'abandonedtflcycle@tfl.gov.uk',
  Bolt = 'londonbikes@bolt.eu',
}

export const HIRE_BIKE_COMPANIES = [
  {
    title: HireBikeCompanies.Bolt,
    image: bolt,
  },
  {
    title: HireBikeCompanies.Forest,
    image: forest,
  },
  {
    title: HireBikeCompanies.ForestRiver,
    image: forestRiver,
  },
  {
    title: HireBikeCompanies.Lime,
    image: lime,
  },
  {
    title: HireBikeCompanies.Santander,
    image: santander,
  },
  {
    title: HireBikeCompanies.Voi,
    image: voiBike,
  },
];

export const HIRE_BIKE_SCOOTERS = [
  {
    title: HireScooterCompanies.Lime,
    image: limeScooter,
  },
  {
    title: HireScooterCompanies.Voi,
    image: voiScooter,
  },
];
